<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {}
  }
</script>

<style lang="less">
  body {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    margin: 0;
    background: #eeeeee;

    #app {

      h1,
      h2,
      h3,
      h4,
      h5 {
        margin: 0;
        position: relative;
      }

      a {
        text-decoration: none;
      }

      ul,
      li {
        list-style: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue